import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import {
  type MsGraphFilterOptionsMap,
  TypeOptionsEnum,
} from "../../Configuration/MsGraphIntegrationFilterBuilder/helpers";

export type MsGraphIntegrationFilterState = {
  data: MsGraphFilterOptionsMap;
  isLoading: boolean;
  error?: Error;
};

const initialState: MsGraphIntegrationFilterState = {
  data: {} as MsGraphFilterOptionsMap,
  isLoading: false,
  error: undefined,
};

const msGraphIntegrationFilterSlice = createSlice({
  name: `${ReducerNamespaceTypes.Accounts}/${ReducerEntityPrefixTypes.Integrations}/msGraphIntegrationFilter`,
  initialState,
  reducers: {
    fetchBegin(state) {
      state.isLoading = true;
    },
    fetchSuccess(state: MsGraphIntegrationFilterState, action: PayloadAction<MsGraphFilterOptionsMap>) {
      state.data = { ...state.data, ...action.payload };
      state.isLoading = false;
    },
    fetchGroup(state: MsGraphIntegrationFilterState, action: PayloadAction<{ text: string; value: string }[]>) {
      state.data[TypeOptionsEnum.Group] = action.payload;
    },
    fetchFailure(state: MsGraphIntegrationFilterState, action: PayloadAction<Error>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    reset() {
      return { ...initialState };
    },
  },
});

export const { fetchBegin, fetchSuccess, fetchGroup, fetchFailure, reset } = msGraphIntegrationFilterSlice.actions;

export default msGraphIntegrationFilterSlice.reducer;
